import { Avatar, Stack, type StackProps } from "@mui/material";

export default function ExpertAvatar({
  src,
  size,
  ...rest
}: {
  size: number;
  src: string | null | undefined;
} & StackProps) {
  // src = src?.startsWith("/file-storage")
  //   ? `${rootService.rootOrigin}${src}`
  //   : src;

  return (
    <Stack width={size} height={size} flexShrink={0} {...rest}>
      <Avatar
        src={src ?? ""}
        sx={{
          width: "100%",
          height: "100%",
          cursor: "pointer",
        }}
      />
    </Stack>
  );
}
